import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GoBackBtn from '../components/goBackBtn';
import CouponList from '../components/couponList';
// import VerifyCodeBtn from "../components/verifyCodeBtn";
import FinishModal from '../components/redeemPage/finishModal';
import ErrorModal from '../components/errorModal';
import Loading from '../components/loading';
import styles from '../styles/Redeem.module.scss';
import API from '../services/api';
import moment from 'moment';
import store from 'store-js';
import { useTranslation } from 'react-i18next';
import imageCompression from 'browser-image-compression';
import { useCookieState } from 'ahooks';

export default function Redeem({ config }) {
    const pageSetting = config.redeemPage_setting;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });

    const firstReceiptRef = useRef(null);
    const secondReceiptRef = useRef(null);

    // const [customerId, setCustomerId] = useState(null);
    const [savedQRcode, setSavedQRcode] = useState(null);
    const [coupons, setCoupons] = useState(null);
    const [totalAmt, setTotalAmt] = useState(null);
    const [expenses, setExpenses] = useState('');
    const [remarks, setRemarks] = useState('');
    const [receipt, setReceipt] = useState('');

    //receipt files
    const [firstReceiptBase64, setFirstReceiptBase64] = useState('');
    const [firstReceiptFile, setFirstReceiptFile] = useState(null);

    const [secondReceiptBase64, setSecondReceiptBase64] = useState('');
    const [secondReceiptFile, setSecondReceiptFile] = useState(null);

    //options
    const [firstReceiptOption, setFirstReceiptOption] = useState(false);
    const [secondReceiptOption, setSecondReceiptOption] = useState(false);

    const [checkValidation, setCheckValidation] = useState(false);

    const [invalidExpenseMsg, setInvalidExpenseMsg] = useState('');

    const [clickedDel, setClickedDel] = useState(false);
    const [openFinishModal, setOpenFinishModal] = useState(false);
    // const [confrimDisabled, setConfirmedDisabled] = useState(false);
    const [redeemID, setRedeemID] = useState(null);

    const [errModalMsg, setErrModalMsg] = useState(null);
    const [showServerErr, setShowServerErr] = useState(false);
    const [consoleMsg, setConsoleMsg] = useState(null);
    const [isPostingData, setIsPostingData] = useState(false);

    const [showRemarksLimitWarning, setShowRemarksLimitWarning] = useState(false);
    const [showReceiptLimitWarning, setShowReceiptLimitWarning] = useState(false);

    const calcTotalQty = (data) => {
        let total = 0;
        for (let i of data) {
            total += Number(i.qty);
        }
        return total;
    };

    const couponHasMinAmount = useMemo(() => {
        // cause now langham only handle one coupon a time, so coupons length must = 0
        if (coupons?.length > 0) {
            return parseInt(coupons[0].minSpendingAmount) > 0;
        }
        return false;
    }, [coupons]);

    const disableConfirmBtn = useMemo(() => {
        return (
            (couponHasMinAmount &&
                (expenses?.trim().length == 0 ||
                    (expenses?.trim().length != 0 &&
                        parseInt(expenses) < parseInt(coupons[0].minSpendingAmount) * calcTotalQty(coupons)))) ||
            totalAmt == null ||
            invalidExpenseMsg.length > 0 ||
            showRemarksLimitWarning ||
            showReceiptLimitWarning ||
            expenses?.trim().length == 0
        );
    }, [
        coupons,
        checkValidation,
        couponHasMinAmount,
        expenses,
        totalAmt,
        invalidExpenseMsg,
        showRemarksLimitWarning,
        showReceiptLimitWarning
    ]);

    useEffect(() => {
        let coupons = store.get('coupons');
        if (coupons) {
            // setCustomerId(coupons[0]?.customer_id);
            setCoupons(coupons);

            store.get('scannedQRcode') ? setSavedQRcode(store.get('scannedQRcode')) : setSavedQRcode([]);

            // set default TotalAmt as coupons total
            let arr = coupons;
            let total = arr.reduce((acc, item) => {
                return acc + Number(item.amt);
            }, 0);
            setTotalAmt(total);
        } else {
            setCoupons([]);
            setSavedQRcode([]);
        }
    }, []);

    useEffect(() => {
        if (coupons) {
            store.set('coupons', coupons);
        }
    }, [coupons]);

    useEffect(() => {
        if (savedQRcode) store.set('scannedQRcode', savedQRcode);
        // Remove saved user if all coupons are deleted
        if (clickedDel && savedQRcode.length === 0) store.remove('owner_customer_id');
        // Reset clickedDel
        setClickedDel(false);
    }, [savedQRcode]);

    // useEffect(() => {
    //     if (
    //         invalidExpenses ||
    //         showRemarksLimitWarning ||
    //         showReceiptLimitWarning ||
    //         (couponHasMinAmount && !receiptFile)
    //     ) {
    //         setConfirmedDisabled(true);
    //         return;
    //     }

    //     // Check coupons length to prevent user del coupons before redeem & send empty redemption
    //     if (
    //         coupons?.length > 0 &&
    //         coupons[0] &&
    //         totalAmt !== null &&
    //         couponHasMinAmount &&
    //         receiptFile
    //         // !invalidExpenses &&
    //         // verifyCode &&
    //         // verifyCode.length === 6
    //     ) {
    //         setConfirmedDisabled(false);
    //     } else setConfirmedDisabled(true);
    // }, [
    //     coupons,
    //     expenses,
    //     receiptFile
    //     // verifyCode,
    //     // showRemarksLimitWarning,
    //     // showReceiptLimitWarning,
    // ]);

    useEffect(() => {
        if (redeemID) setOpenFinishModal(true);
    }, [redeemID]);

    const redirectToScan = () => {
        // store.remove("otpCountDown");
        // sessionStorage.removeItem("OTPref");
        // clearTimeout(window.otpTimeoutID);
        store.remove('coupons');
        store.remove('scannedQRcode');
        navigate('/scanner');
    };

    const handleDelete = (data) => {
        let delCode = data.code;
        setClickedDel(true);

        let newData = coupons.filter((item) => {
            return item !== data;
        });
        setCoupons(newData);

        // Recalculate the totalAmt after coupon removal
        let total = newData.reduce((acc, item) => {
            return acc + Number(item.amt);
        }, 0);
        setTotalAmt(total);

        // ----------
        /* Dummy Code Testing */
        // let savedArr = savedQRcode[0].split(', ');
        // let newScannedQR = savedArr.filter((item) => {
        //     return item !== delCode;
        // });
        // setSavedQRcode(newScannedQR.flat().length < 1 ? [] : [newScannedQR.flat().join(', ')]);
        // ----------

        let newScannedQR = savedQRcode.filter((item) => {
            return item.code !== delCode;
        });
        setSavedQRcode(newScannedQR);
    };

    // const updateTotal = (totalAmt) => {
    //     setTotalAmt(totalAmt);
    // };

    const handleExpensesChange = (e) => {
        // console.log(e.target.value);
        checkInvalidExpense(e.target.value);
        // let val = e.target.value.toString().split('.')[0];
        // let pattern = /^\d+\.{0,1}\d{0,2}$/;

        // if (val.trim().length == 0) {
        //     setInvalidExpenseMsg(couponHasMinAmount ? t('redeem_expenseTotal_input_must_validation_error') : '');
        //     setExpenses('');
        //     return;
        // }

        // if (val.length <= 10) {
        //     setExpenses(
        //         e.target.value
        //             .toString()
        //             .split('.')
        //             .map((el, i) => (i ? el.split('').slice(0, 1).join('') : el))
        //             .join('.')
        //     );
        //     setInvalidExpenseMsg('');
        // }

        // if (!pattern.test(e.target.value)) {
        //     setInvalidExpenseMsg(t('redeem_expenseTotal_input_error'));
        // }
    };

    const handleRemarksChange = (e) => {
        let remarksVal = e.target.value;
        if (remarksVal.length <= 30) {
            setRemarks(e.target.value);
            setShowRemarksLimitWarning(false);
        } else {
            setShowRemarksLimitWarning(true);
            // setConfirmedDisabled(true);
        }
    };

    const handleReceiptChange = (e) => {
        let receiptVal = e.target.value.toString();
        if (receiptVal.length <= 45) {
            setReceipt(e.target.value);
            setShowReceiptLimitWarning(false);
        } else {
            setShowReceiptLimitWarning(true);
            // setConfirmedDisabled(true);
        }
    };

    // Create new record object
    const createNewRecord = (refId) => {
        // Extract code from the objs inside coupons
        let couponArr = [];
        coupons.map((item) => {
            couponArr.push(item.code);
        });

        // Extract oneTimeCodeRef from the objs inside coupons
        let refArr = [];
        coupons.map((item) => {
            if (!refArr.includes(item.oneTimeRef)) {
                refArr.push(item.oneTimeRef);
            }
        });

        let newRecord = {
            vouchers: couponArr,
            oneTimeRef: refArr,
            spending_amount: expenses?.length < 1 ? 0 : expenses,
            receipt: receipt === '' ? '-' : receipt,
            remarks: remarks === '' ? '-' : remarks,
            reference_id: refId
        };
        return newRecord;
    };

    const removeStoredItems = () => {
        let keysToRemove = ['coupons', 'scannedQRcode', 'owner_customer_id', 'otpCountDown'];
        for (let key of keysToRemove) {
            store.remove(key);
        }
        // sessionStorage.remove("OTPref");
    };

    const checkInvalidExpense = (expenseText) => {
        let pattern = /^\d+\.{0,1}\d{0,2}$/;
        expenseText = expenseText?.trim();
        expenseText = expenseText.split('.')[0];
        if (expenseText.length == 0) {
            setInvalidExpenseMsg(
                expenseText?.trim().length == 0 ? t('redeem_expenseTotal_input_must_validation_error') : ''
            );
            setExpenses('');
            return;
        } else if (expenseText.length > 0 && expenseText.length < 10) {
            setExpenses(
                expenseText
                    .toString()
                    .split('.')
                    .map((el, i) => (i ? el.split('').slice(0, 1).join('') : el))
                    .join('.')
            );
            if (
                couponHasMinAmount &&
                expenseText?.trim().length != 0 &&
                parseInt(expenseText) < parseInt(coupons[0].minSpendingAmount) * calcTotalQty(coupons)
            ) {
                setInvalidExpenseMsg(t('redeem_expenseTotal_min_spending_error'));
            } else {
                setInvalidExpenseMsg('');
            }
        }
        if (!pattern.test(expenseText)) {
            setInvalidExpenseMsg(t('redeem_expenseTotal_input_error'));
        }
    };

    // const hasInvalidData = () => {
    //     setCheckValidation(true);
    //     checkInvalidExpense(expenses);
    //     return (
    //         invalidExpenseMsg.length > 0 || showRemarksLimitWarning || showReceiptLimitWarning
    //         (couponHasMinAmount && !receiptFile)
    //     );
    // };

    const handleError = (res) => {
        setShowServerErr(true);
        setIsPostingData(false);

        switch (res?.payload?.error_code) {
            case '4518':
                setErrModalMsg('電子券使用中，請稍後再試' + ' (P1)');
                break;
            case '4520':
                setErrModalMsg(t('scannerErr_notEnoughCodes') + ' (P2)');
                break;
            case '4522':
                setErrModalMsg('電子券已使用');
                break;
            default:
                setConsoleMsg(2);
                console.log(res?.response?.message);
                break;
        }
    };

    const handleSuccess = (refId) => {
        setRedeemID(refId);
        removeStoredItems();

        setOpenFinishModal(false);

        if (couponHasMinAmount) {
            navigate('/UploadReceipt', { state: { redeemID: refId } });
        } else navigate('/records');
    };

    // const uploadFiles = async (file_arr) => {
    //     try {
    //         const api = new API(token);
    //         var options = {
    //             maxSizeMB: 1,
    //             maxWidthOrHeight: 1920,
    //             useWebWorker: true
    //         };
    //         const uploadPromises = file_arr.map(async (file) => {
    //             const compressedFile = await imageCompression(file, options);
    //             console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
    //             console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
    //             return api.uploadMedia(customerId, compressedFile); // Use compressedFile instead of file
    //         });
    //         const results = await Promise.all(uploadPromises);
    //         return results;
    //         // return await Promise.all(uploadPromises);
    //     } catch (error) {
    //         console.error('Error uploading files:', error);
    //     }
    // };

    const redeemVoucher = async () => {
        const api = new API(token);
        try {
            let storeCode = store.get('merchant_id');
            if (!storeCode) {
                const infoRes = await api.getMerchantInfo();
                if (infoRes && !infoRes.hasOwnProperty('error')) {
                    storeCode = Object.values(infoRes.payload.stores)[0].code;
                    store.set('merchant_id', storeCode);
                } else {
                    handleError(infoRes);
                    return;
                }
            }

            // Update RedeemID - "F" + Clix Store ID + RedemptionYYMMDD + 4 dig random no.
            let random = Math.floor(1000 + Math.random() * 9000);
            let refId = `F${storeCode}${moment().format('YYMMDD')}${random}`;
            let recordObj = createNewRecord(refId);

            const res = await api.redeemVoucher(recordObj);
            setIsPostingData(false);
            if (res?.response?.code === '200') {
                store.set('useHistoryId', res?.payload.id);
                store.set('customerId', res?.payload.customer_id);
                handleSuccess(refId);
            } else if (res?.response?.code === '400') {
                handleError(res);
            }
        } catch (err) {
            setShowServerErr(true);
            setConsoleMsg(t('errMsg_networkErr'));
            setIsPostingData(false);
            console.log(err);
        }
    };

    const handleSubmit = async () => {
        setIsPostingData(true);
        await redeemVoucher();
        // if (file_arr.length > 0) {
        //     try {
        //         const res = await uploadFiles(file_arr);
        //         const media_res_arr = res
        //             .filter((r) => r?.response?.code === '200')
        //             .map((r) => ({
        //                 media_id: r.payload.id,
        //                 token: r.payload.token,
        //                 file_path: r.payload.file_path
        //             }));
        //         await redeemVoucher(media_res_arr);
        //     } catch (err) {
        //         setShowServerErr(true);
        //         setConsoleMsg(t('errMsg_networkErr'));
        //         setIsPostingData(false);
        //         console.log(err);
        //     }
        // } else {
        //     await redeemVoucher(file_arr);
        // }
    };

    const handleConfirm = () => {
        // if (hasInvalidData()) {
        //     return;
        // }
        // setIsPostingData(true);

        setTimeout(async () => {
            // let file_arr = [];
            // if (firstReceiptFile) {
            //     file_arr.push(firstReceiptFile);
            // }
            // if (secondReceiptFile) {
            //     file_arr.push(secondReceiptFile);
            // }
            await handleSubmit();
        }, 0);
    };

    const handleCloseErrModal = () => {
        setShowServerErr(false);
        setConsoleMsg(null);
    };

    const onChangeReceipt = (event, type) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        if (file) {
            if (type === 'first') setFirstReceiptFile(file);
            else setSecondReceiptFile(file);

            reader.onload = function (e) {
                console.log('e.target.result', e.target.result);
                if (type === 'first') setFirstReceiptBase64(e.target.result);
                else setSecondReceiptBase64(e.target.result);
                // document.getElementById("image-preview").src = e.target.result;
            };

            reader.readAsDataURL(file);
        }
    };

    return (
        <div className="marginContent noselect">
            <div className={styles.content}>
                <div className="backBtnDiv">
                    <GoBackBtn
                        color={`${config.theme.color}`}
                        // timeoutID={window.otpTimeoutID}
                    />
                    <button className="colorBtn contBtn" type="button" onClick={redirectToScan}>
                        {t('redeem_backToScan_btn_label')}
                    </button>
                </div>
                <CouponList
                    data={coupons}
                    handleDelete={handleDelete}
                    // updateTotal={updateTotal}
                    t={t}
                    config={config}
                    pageSetting={pageSetting}
                />
                <div className={styles.inputsDiv}>
                    <label>{t('redeem_expenseTotal_input_label')}</label>
                    <input
                        id="expenses"
                        value={expenses}
                        inputMode="decimal"
                        pattern="^\d+\.{0,1}\d{0,2}$"
                        type="text"
                        // style={{
                        //     borderColor: invalidExpenseMsg.length > 0 ? '#D46666' : '#cacaca'
                        // }}
                        onChange={(e) => handleExpensesChange(e)}
                    />
                    <p
                        style={{
                            color: '#D46666',
                            display: invalidExpenseMsg.length > 0 ? 'block' : 'none'
                        }}
                    >
                        {invalidExpenseMsg}
                    </p>

                    <label>{t('redeem_remarks_input_label')}</label>
                    <input type="text" id="remarks" value={remarks} onChange={(e) => handleRemarksChange(e)} />
                    <p
                        style={{
                            color: '#D46666',
                            display: showRemarksLimitWarning ? 'block' : 'none'
                        }}
                    >
                        {t('redeem_remarks_input_error')}
                    </p>

                    <label>{t('redeem_receipt_input_label')}</label>
                    <input type="text" id="receipt" value={receipt} onChange={(e) => handleReceiptChange(e)} />
                    <p
                        style={{
                            color: '#D46666',
                            display: showReceiptLimitWarning ? 'block' : 'none'
                        }}
                    >
                        {t('redeem_receipt_input_error')}
                    </p>
                    {/* {couponHasMinAmount && (
                        <>
                            <label>{t('redeem_upload_receipt_label_1')}</label>
                            <label className="boldThemeTxt">{t('redeem_upload_receipt_label_2')}</label>
                            <div className={styles.uploadReceiptDiv}>
                                <label
                                    className={
                                        firstReceiptOption === 'now' ? styles.receiptInputSelected : styles.receiptInput
                                    }
                                    onClick={() => setFirstReceiptOption('now')}
                                >
                                    <>{t('redeem_uploadReceiptNowBtn')}</>
                                </label>
                                <label
                                    className={
                                        firstReceiptOption === 'later'
                                            ? styles.receiptInputSelected
                                            : styles.receiptInput
                                    }
                                    onClick={() => {
                                        setFirstReceiptOption('later');
                                        setFirstReceiptBase64('');
                                        setFirstReceiptFile(null);
                                    }}
                                >
                                    <>{t('redeem_uploadReceiptLaterBtn')}</>
                                </label>
                            </div>
                            {firstReceiptOption === 'now' && (
                                <button
                                    className="colorBtn contBtn"
                                    type="button"
                                    onClick={() => firstReceiptRef.current.click()}
                                >
                                    {t('redeem_uploadReceiptBtn')}
                                </button>
                            )}
                            <input
                                ref={firstReceiptRef}
                                id="receipt-file-upload-first"
                                type="file"
                                accept="image/*"
                                onChange={(event) => {
                                    onChangeReceipt(event, 'first');
                                }}
                                key={moment().unix()}
                            />
                            {firstReceiptBase64 && (
                                <img
                                    id="image-preview-first"
                                    src={firstReceiptBase64}
                                    style={{
                                        width: '120px',
                                        height: '120px',
                                        marginTop: 12
                                    }}
                                />
                            )}
                            <label className="boldThemeTxt">{t('redeem_upload_receipt_label_3')}</label>
                            <div className={styles.uploadReceiptDiv}>
                                <label
                                    className={
                                        secondReceiptOption === 'now'
                                            ? styles.receiptInputSelected
                                            : styles.receiptInput
                                    }
                                    onClick={() => setSecondReceiptOption('now')}
                                >
                                    <>{t('redeem_uploadReceiptNowBtn')}</>
                                </label>
                                <label
                                    className={
                                        secondReceiptOption === 'later'
                                            ? styles.receiptInputSelected
                                            : styles.receiptInput
                                    }
                                    onClick={() => {
                                        setSecondReceiptOption('later');
                                        setSecondReceiptBase64('');
                                        setSecondReceiptFile(null);
                                    }}
                                >
                                    <>{t('redeem_uploadReceiptLaterBtn')}</>
                                </label>
                            </div>
                            {secondReceiptOption === 'now' && (
                                <button
                                    className="colorBtn contBtn"
                                    type="button"
                                    onClick={() => secondReceiptRef.current.click()}
                                >
                                    {t('redeem_uploadReceiptBtn')}
                                </button>
                            )}
                            <input
                                ref={secondReceiptRef}
                                id="receipt-file-upload-second"
                                type="file"
                                accept="image/*"
                                onChange={(event) => {
                                    onChangeReceipt(event, 'second');
                                }}
                                key={moment().unix()}
                            />
                            {secondReceiptBase64 && (
                                <img
                                    id="image-preview-second"
                                    src={secondReceiptBase64}
                                    style={{
                                        width: '120px',
                                        height: '120px',
                                        marginTop: 12
                                    }}
                                />
                            )}
                        </>
                    )} */}

                    <button
                        className="colorBtn"
                        type="button"
                        disabled={disableConfirmBtn || isPostingData}
                        style={{
                            backgroundColor: disableConfirmBtn || isPostingData ? '#888888' : config.theme.color
                        }}
                        onClick={handleConfirm}
                    >
                        {t('redeem_confirmBtn')}
                    </button>
                </div>

                {isPostingData && (
                    <div className="loadingBg">
                        <Loading
                            className="loadingBtn"
                            color={config.theme.color}
                            style={{
                                width: '50px',
                                height: '50px'
                            }}
                        />
                    </div>
                )}

                <FinishModal openModal={openFinishModal} redeemID={redeemID} t={t} config={config} />

                <ErrorModal
                    openModal={showServerErr}
                    errorMsg={errModalMsg}
                    consoleMsg={consoleMsg}
                    handleCloseModal={handleCloseErrModal}
                    t={t}
                    config={config}
                />
            </div>
        </div>
    );
}
